'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import CartesianGraph from './CartesianGraph';
import PolarGraph from './PolarGraph';

const GRAPH_SIZE = 300;

function CartesianVsPolar() {
  return (
    <Wrapper>
      <Col>
        <Heading>Cartesian Coordinates</Heading>
        <CartesianGraph size={GRAPH_SIZE} />
      </Col>
      <Col>
        <Heading>Polar Coordinates</Heading>
        <PolarGraph size={GRAPH_SIZE} />
      </Col>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --main-color-fragment: 250deg 100% 66%;
  --main-color: hsl(var(--main-color-fragment));

  display: flex;
  gap: 64px 16px;
  flex-wrap: wrap;
  margin-top: 2rem;
  margin-bottom: 5rem;

  html[data-color-mode='dark'] & {
    --main-color-fragment: 50deg 100% 60%;
    --main-color: hsl(var(--main-color-fragment));
  }
`;

const Col = styled.div`
  flex: 1;
`;

const Heading = styled.h3`
  font-family: var(--font-family-mono);
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  margin-bottom: 2rem;
  text-transform: uppercase;
  text-align: center;
  opacity: 0.7;
`;

export default CartesianVsPolar;
